












import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IEditBehavior } from "../../../../domain/format/objects";

@Component
export default class EditBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditBehavior) => T, defaultValue: T) => T;

  get isVisible(): boolean {
    return this.readPropertyOrDefault(s => s.isVisible, false);
  }

  set isVisible(value: boolean) {
    this.writePropertyWhenValid(s => s.isVisible = value);
  }
}
